import { useRecentEventForCurrentMode } from "../../../../../hooks/useRecentEventForCurrentMode";
import { LaunchAngleVis } from "../../svg/LaunchAngleVis";

interface Props {
  style?: React.CSSProperties;
}

export const LaunchAngle = ({ style }: Props) => {
  const { hit_data } = useRecentEventForCurrentMode();
  const launchAngle = hit_data?.AngleDegrees;

  return <LaunchAngleVis style={style} launchAngle={launchAngle} />;
};
